<template>
  <v-container fluid tag="section" class="d-flex justify-center" style="height: calc(100vh - 162px);">
    <v-row style="max-width: 92%;" :class="{'pt-9': $vuetify.breakpoint.xlOnly}">
      <v-col cols="5" class="font-weight-light">
        <p class="mb-4 pr-4 display-4 billit--text font-weight-bold">
          <!-- <span class="display-2">Billit Medical's</span> <br>  -->
          Webdesk Support
        </p>
        <p>Webdesk is a solution offered by Billit to assist organizations into adjusting to their use of Billit more quickly and efficiently with our help!</p>
        <div style="width: 60px; height: 5px; opacity: 0.6;" class="billit darken-1 mt-5 mb-7"></div>
        <p class="pt-2">
          Our webdesk team specializes in the following solutions:
        </p>
        <ol class="webdesk-list" :class="{'mb-9 mt-6': $vuetify.breakpoint.xlOnly}">
          <li><span class="font-weight-light">Professional training videos for using Billit to assist in different situations and scenarios (including use case videos, complete setup live streams, snippet instructions, and more).</span></li>
          <br>
          <li><span class="font-weight-light">A completed setup of your accepted insurance carriers and plans, and writing out the customized billing instructions your practice has for each of those plans depending on your billing method.</span></li>
          <br>
          <li><span class="font-weight-light">Custom feature requests for Billit that integrate into your practice's systems.</span></li>
        </ol>
        <v-btn target="_blank" href="mailto:hello@getbillit.com" color="billit" class="ml-3 mt-8 mb-6 font-weight-bold" outlined style="border: 3px solid #55E6CC; border-radius: 8px;" large>Contact Us</v-btn>
        <p style="font-size: 13px;" class="font-weight-light pl-3 pr-12">
          <span v-if="$store.state.practiceData.isBetaParticipant">As a member of our early supporter program, you're eligible for a <span class="font-weight-medium">lifetime discount</span> for webdesk support. Contact us for a quote!</span>
          <span v-else>We'll prepare your Billit setup to integrate with your practice. Contact us for a quote!</span>
        </p>
        
      </v-col>
    </v-row>
    <v-img eager max-width="43vw" style="position: absolute; right: 4%; bottom: 15%;" :src="require('@/assets/art/webdesk.svg')" />
  </v-container>
  <!-- <base-material-snackbar
    v-model="snackbar"
    :type="color"
    v-bind="{
      [parsedDirection[0]]: true,
      [parsedDirection[1]]: true
    }"
  >
    Welcome to <span class="font-weight-bold">&nbsp;MATERIAL DASHBOARD&nbsp;</span> — a beautiful admin panel for every web developer.
  </base-material-snackbar>-->
</template>


<script>
export default {
  
}
</script>

<style>
.webdesk-list li {
  font-weight: 450;
}
</style>